import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * 初期型
 */
export interface MatchedTagsState {
  matchedTags: string[];
}

/**
 * Slice型
 */
export interface MatchedTagsSliceState {
  matchedTags: ReturnType<typeof matchedTagsReducer>;
}

/**
 * 初期状態
 */
export const matchedTagsInitialState: MatchedTagsState = {
  matchedTags: [],
};

/**
 * slice
 */
const matchedTagsSlice = createSlice({
  name: 'matchedTags',
  initialState: matchedTagsInitialState,
  reducers: {
    setMatchedTags: (state, action: PayloadAction<string[]>) => {
      state.matchedTags = action.payload;
    },
  },
});

export const { setMatchedTags } = matchedTagsSlice.actions;

export const matchedTagsReducer = matchedTagsSlice.reducer;

type State = MatchedTagsSliceState;

/**
 * Selector matchedTagsSelector
 * @param state
 * @returns matchedTags
 */
export const matchedTagsSelector = <S extends State>(state: S) =>
  state.matchedTags.matchedTags;
